import { styled } from 'styled-components'
import { theme } from './theme'

export const Styled_Table_Wrapper = styled.section`
  width: 100%;
  max-width: 2000px;
`

export const Styled_Table = styled.table`
  width: 100%;
  table-layout: fixed; // 고정된 테이블 레이아웃
  border-collapse: collapse;
  margin: 0 0 10px 0;
  font-size: 18px;
  text-align: left;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1);

  th,
  td {
    padding: 12px 15px;
    white-space: nowrap; /* 줄바꿈 방지 */
    overflow: hidden; /* 넘치는 텍스트 숨김 */
    text-overflow: ellipsis; /* 넘치는 텍스트를 ...으로 표시 */
    border: 1px solid ${theme.colors.gray};
    position: relative; /* 호버 시에 내용이 보이도록 하기 위한 설정 */
  }

  thead {
    background-color: ${theme.colors.green};
    color: ${theme.colors.white};
  }

  tbody tr {
    border-bottom: 1px solid ${theme.colors.gray};
  }

  tbody tr:nth-of-type(even) {
    background-color: ${theme.colors.whitegray};
  }

  tbody tr:last-of-type {
    border-bottom: 2px solid ${theme.colors.green};
  }

  tbody tr:hover {
    background-color: ${theme.colors.yellowgreen};
  }

  th:hover,
  td:hover {
    white-space: normal; /* 호버 시 줄바꿈 허용 */
    word-wrap: break-word; /* 셀 내용이 길 경우 줄바꿈 */
    overflow: visible; /* 호버 시 넘치는 텍스트 표시 */
    text-overflow: clip; /* 호버 시 텍스트 잘림 없이 모두 표시 */
  }

  th:hover::after,
  td:hover::after {
    position: absolute;
    background: ${theme.colors.white};
    border: 1px solid ${theme.colors.gray};
    padding: 5px;
    z-index: 10;
    left: 0;
    top: 100%;
    white-space: normal; /* 줄바꿈 허용 */
  }
  .clickable {
    cursor: pointer;
    color: ${theme.colors.blue}
  }
  .clickable:hover {
    /* text-decoration: underline; */
  }
  .Loading {
    filter: blur(10px);
    pointer-events: none;
  }
`

export const Table_Info = styled.div`
  display: flex;
  width: 100%;
  height: 61px;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  font-weight: bold;
  caption-side: top; /* 캡션을 테이블 상단에 위치시키는 속성 */
`
